import React from "react";
import "animate.css";
import "../../App.css";

const Competences = () => {
  return (
    <section
      id="competences"
      className="min-h-screen bg-gray-100 flex flex-col justify-center items-center py-12 px-4 md:px-8 lg:px-16"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-[#03224C] mb-8 animate__animated animate__fadeIn text-center">
        Compétences
      </h2>

      <p className="text-base md:text-lg text-black mb-12 text-center animate__animated animate__zoomIn animate__delay-1s max-w-3xl">
        Elles sont en constantes améliorations car pour moi la joie de ce métier
        fait que l’on en apprend tous les jours...
      </p>

      {/* Grille des compétences */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full max-w-6xl animate__animated animate__fadeInUp animate__delay-2s">
        {/* FRONT-END */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-blue-600">
            FRONT-END
          </h3>
          <ul className="space-y-4 text-black">
            <li>
              <span>HTML</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: "95%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>CSS</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: "95%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>REACT</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>Bootstrap</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>Tailwind</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-blue-600 h-2 rounded-full"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </li>
          </ul>
        </div>

        {/* BACK-END */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-green-600">
            BACK-END
          </h3>
          <ul className="space-y-4 text-black">
            <li>
              <span>PHP</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: "85%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>C#/ASP.NET</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: "85%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>JAVA/JEE</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>Node.js/Express.js</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: "75%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>Python/Django/Flask</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-green-600 h-2 rounded-full"
                  style={{ width: "70%" }}
                ></div>
              </div>
            </li>
          </ul>
        </div>

        {/* BASE DE DONNEES */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-red-600">
            BASE DE DONNEES
          </h3>
          <ul className="space-y-4 text-black">
            <li>
              <span>SQL Server</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-red-600 h-2 rounded-full"
                  style={{ width: "90%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>MySQL</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-red-600 h-2 rounded-full"
                  style={{ width: "95%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>Oracle</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-red-600 h-2 rounded-full"
                  style={{ width: "80%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>MongoDB</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-red-600 h-2 rounded-full"
                  style={{ width: "90%" }}
                ></div>
              </div>
            </li>
          </ul>
        </div>

        {/* CMS */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-purple-600">
            CMS
          </h3>
          <ul className="space-y-4 text-black">
            <li>
              <span>WordPress</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-purple-600 h-2 rounded-full"
                  style={{ width: "90%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>PRESTASHOP</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-purple-600 h-2 rounded-full"
                  style={{ width: "90%" }}
                ></div>
              </div>
            </li>
            <li>
              <span>JOOMLA</span>
              <div className="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div
                  className="bg-purple-600 h-2 rounded-full"
                  style={{ width: "90%" }}
                ></div>
              </div>
            </li>
          </ul>
        </div>

        {/* OUTILS BUREAUTIQUE */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-yellow-600">
            OUTILS BUREAUTIQUE
          </h3>
          <ul className="space-y-4 text-black">
            <li>Word</li>
            <li>Excel</li>
            <li>Access</li>
            <li>PowerPoint</li>
          </ul>
        </div>

        {/* AUTRES */}
        <div className="bg-white shadow-lg p-6 md:p-8 rounded-lg">
          <h3 className="text-xl md:text-2xl font-semibold mb-6 text-gray-600">
            AUTRES
          </h3>
          <ul className="space-y-4 text-black">
            <li>Agile/DevOps</li>
            <li>Git/Github</li>
            <li>UML/MERISE</li>
            <li>Adobe XD/Figma</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Competences;
